import React from "react";

export default function MySQL_IFNULL() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_IFNULL</h1>
      <p>This is the MySQL_IFNULL component generated from the SQL JSON.</p>
    </div>
  );
}
